import {Component, Host, OnInit} from '@angular/core';
import {ProductsComponent} from "../products.component";
import {ProductsService} from "../../../../services/products/products.service";

@Component({
  selector: 'app-active-gestionProduits',
  templateUrl: './active-products.component.html',
  styleUrls: ['./active-products.component.scss']
})
export class ActiveProductsComponent implements OnInit {
  public contentHeader: object;
  constructor(public shared: ProductsService) {}

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Produits & Services',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Produits & Services',
            isLink: true,
            link: '/archive'
          },
          {
            name: 'Produits & Services',
            isLink: false
          }
        ]
      }
    }
  }


  get filteredItems() {
    return this.shared.items
        .filter(item => item.status === 'actif')
        .filter(item =>
            !this.shared.searchText ||
            item.name.toLowerCase().includes(this.shared.searchText.toLowerCase()) ||
            item.ref.toLowerCase().includes(this.shared.searchText.toLowerCase())
        );
  }

}
